<template>
    <Link :href="route('episodes.show', episode)" @mouseover="hover = true" @mouseleave="hover = false" class="w-full flex bg-white p-4 space-x-4 rounded-lg">
        <div class="shrink-0 w-32 h-32 bg-cover bg-center rounded-md" :style="'background-image: url(' + episode.image + ')'" />
        <div class="w-full flex flex-col justify-between pt-0.5">
            <div class="font-medium line-clamp-2 leading-tight text-lg transition-colors duration-100 ease-out cursor-pointer" :class="{ 'text-regal-blue-700': hover}">
                {{ episode.title }}
            </div>
            <div class="flex space-x-3 text-sm text-gray-700 font-medium items-center">
                <div class="">
                    <div class="flex items-center justify-center text-white w-10 h-10 rounded-full transition-colors duration-100 ease-out cursor-pointer" :class="{ 'bg-regal-blue-700': hover, 'bg-gray-500': !hover}">
                        <svg class="fill-current w-4 h-4 -mr-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg>
                    </div>
                </div>
                <div class="text-xs text-gray-700 flex space-x-1 items-center font-medium">
                    <div class="line-clamp-1">
                        {{ episode.published_at }}
                    </div>
                    <div class="">
                        •
                    </div>
                    <div v-if="episode.played" class="flex items-center space-x-1 text-regal-blue-700">
                        <div class="text-gray-700">
                            Played
                        </div>
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>

                    </div>
                    <div v-if="!episode.played && episode.remaining" class="line-clamp-1">
                        {{ episode.remaining }} left
                    </div>
                    <div v-if="!episode.remaining" class="line-clamp-1">
                        {{ episode.duration }}
                    </div>
                    <div v-if="!episode.played && episode.percentPlayed !== 0" class="flex-1 flex justify-end shrink-0">
                        <div class="w-12 h-1 relative">
                            <div class="absolute z-20 bg-regal-blue-700 rounded-full h-1" :style="'width: ' + episode.percentPlayed + '%'" />
                            <div class="relative z-10 bg-gray-400 w-full rounded-full h-1" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Link>
</template>

<script>
import { ref } from 'vue'

export default {
    setup() {
        const hover = ref(false)
        return { hover }
    },
    props: [ 'episode', 'podcast' ]
}
</script>
